import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from "react";
import { Helmet } from "react-helmet-async";


const FaviconContext = createContext<Dispatch<SetStateAction<string>> | null>(null);


export default function FaviconProvider({ children }: { children: ReactNode }) {
  const [faviconHref, setFaviconHref] = useState("/favicon.ico");

  return (
    <FaviconContext.Provider value={setFaviconHref}>
      <Helmet>
        <link rel={"icon"} href={faviconHref} />
      </Helmet>
      {children}
    </FaviconContext.Provider>
  );
}

export const useSetFaviconHref = () => {
  const faviconContext = useContext(FaviconContext);

  if (!faviconContext) {
    throw new Error("useSetFaviconHref must be used within a FaviconProvider");
  }

  return faviconContext;
};
